// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"680":"abcf8afa","835":"1442031b"}[chunkId] + ".js";
};